document.addEventListener("click", function (e) {
  const item = e.target.closest(".choices__item--selectable");
  if (!item) return;
  e.stopPropagation(); // prevent bubbling
  const dropdown = item.closest(".pack-product-select").querySelector(".choices__list--dropdown");
  // Close all other dropdowns
  document.querySelectorAll(".choices__list--dropdown").forEach((d) => {
    if (d !== dropdown) {
      d.classList.remove("active");
      d.style.display = "none";
    }
  });

  // Toggle current dropdown
  if (dropdown.classList.contains("active")) {
    dropdown.classList.remove("active");
    dropdown.style.display = "none";
  } else {
    dropdown.classList.add("active");
    dropdown.style.display = "block";
  }
});

// Click outside to close all dropdowns
document.addEventListener("click", function (e) {
  if (!e.target.closest(".pack-product-select")) {
    document.querySelectorAll(".choices__list--dropdown").forEach((d) => {
      d.classList.remove("active");
      d.style.display = "none";
    });
  }
});

document.addEventListener('click', function (e) {
  const item = e.target.closest('.pack-selection-item.choice');
  if (!item) return; // ignore other clicks

  // find the main wrapper for this product
  const productWrapper = item.closest('.pack-product-select');
  if (!productWrapper) return;

  // find the clicked choice
  const parentChoice = item.closest('.choices__item--selectable');
  if (!parentChoice) return;

  // get values from attributes
  const qty = parentChoice.getAttribute('data-value') || '';
  const packValue = parentChoice.getAttribute('data-pack') || '';
  const packPrice = parentChoice.getAttribute('data-price') || '';
  const packUnit = parentChoice.getAttribute('data-unit') || '';

  // find all choice items only within this product
  const allChoices = productWrapper.querySelectorAll('.choices__item--selectable');

  // remove 'is-selected' from all icons in this product only
  allChoices.forEach(choice => {
    const icon = choice.querySelector('.icon-check');
    if (icon) icon.classList.remove('is-selected');
  });

  // add 'is-selected' only to the clicked one
  const clickedIcon = parentChoice.querySelector('.icon-check');
  if (clickedIcon) clickedIcon.classList.add('is-selected');

  // update only this product’s pack info
  const nameEl = productWrapper.querySelector('.product-pack-card__cta .pack-name');
  const priceEl = productWrapper.querySelector('.product-pack-card__cta .pack-price');
  const unitEl = productWrapper.querySelector('.product-pack-card__cta .unit-price');

  if (nameEl) nameEl.textContent = packValue;
  if (priceEl) priceEl.textContent = packPrice;
  if (unitEl) unitEl.textContent = packUnit;

  // find sibling `.product-card__list-actions` and update qty input
  const siblingActions = productWrapper.parentElement.querySelector('.product-card__list-actions');
  if (siblingActions) {
    const qtyInput = siblingActions.querySelector('.qty-input__input');
    if (qtyInput) qtyInput.value = qty;
  }
});
